import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { WcBreadcrumb } from "../components/WcBreadcrumb";
import { WcExplainer } from "../components/WcExplainer";
import { WordCounter } from "../components/WordCounter";

export function WordCounterPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <WcBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.wc_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.wc_intro()}
          </p>
        </header>

        <WordCounter />

        <WcExplainer
          howTo={m.wc_howto()}
          faqs={[
            { q: m.wc_faq1_q(), a: m.wc_faq1_a() },
            { q: m.wc_faq2_q(), a: m.wc_faq2_a() },
            { q: m.wc_faq3_q(), a: m.wc_faq3_a() },
            { q: m.wc_faq4_q(), a: m.wc_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
